import React, {Component} from 'react';
import VideoEdit from '../../components/EditChapterPart/VideoEdit'
import {Link} from 'react-router-dom';
import VideoEditContainer from '../../containers/EditChapterPart/VideoEditContainer';
import EditVideoQuestionsContainer from "../../containers/EditChapterPart/EditVideoQuestionsContainer";
import EditQuizQuestionsContainer from "../../containers/EditChapterPart/EditQuizQuestionsContainer";
import EditBasicInfoContainer from "../../containers/EditChapterPart/EditBasicInfoContainer"
import VideoDiscussion from '../Video/VideoDiscussion';
import ModalDeleteDiscussions from './ModalDeleteDiscussions';
import LectureDropdownContainer from '../../containers/EditChapterPart/LectureDropdownContainer';

import '../../video.css?v=1.0';

const marks = [
    {
        time: 60,
        question: "What once-great console developer now publishes DragonBallZ games?",
        answer: "Atari",
        answerAt: 38,
        attempts: 0,
        completed: false,
        tag: 'MCQ'
    },
    {
        time: 299,
        question: "What year was the Sega Saturn released?",
        answer: "1995",
        answerAt: 198,
        attempts: 0,
        completed: false,
        tag: 'MCQ'
    },
    {
        time: 420,
        question: "How many polygons per second could the Playstation 2 render?",
        answer: "60 million",
        answerAt: 338,
        attempts: 0,
        completed: false,
        tag: 'MCQ'
    }
]

class EditChapterPart extends Component {
    state = {
        timeRewindTo: '',
        chapterId: 0,
        urlParams: {},
        marks: marks,
        view: "add",
        image: null,
        showDeleteModal: false,
        calledLoad: false,
    };

    //Actions
    getTimeToRewind = (time) => {
        this.setState({
            timeRewindTo: time
        });
    };

    //Renders
    renderContentHeader = () => {
        let params = {};
        let splitSearch = this.props.location.search.replace('?', '').split('&');
        splitSearch.map(item => {
            let param = item.split('=');
            params[param[0]] = param[1];
        });

        let view = (params.hasOwnProperty("id")) ? "edit" : "add";
        let number = 0;
        if(this.props.chapterPartInfo.number){
            number = parseInt(this.props.chapterPartInfo.number);
        }
        
        number += 1;
        return (
            <div className="bg-light lter b-b wrapper-md">
                <div className="row">
                
                    <div className="col-sm-3 col-xs-3">
                        <h1 className="m-n font-thin h3 text-black">
                            <Link className="back-button" to={`/course-admin/${this.props.chapterPartInfo.courseId ? this.props.chapterPartInfo.courseId :''}`}>
                                <i className={"zmdi zmdi-arrow-left"}></i>
                            </Link> {(!this.props.match.params.lectureId) ? 'Add' : 'Edit'} Chapter Details
                        </h1>
                        <small className="text-muted">
    
                        </small>
                    </div>
                    <div className="col-sm-6 text-center">
                        {this.props.chapterPartInfo ?
                            this.props.chapterPartInfo.courseId ?
                                <LectureDropdownContainer courseId={this.props.chapterPartInfo.courseId} currentId={this.props.chapterPartInfo.id} />
                            : null
                        : null}
                    </div>
                    <div className="col-sm-3 text-right">
                    
                        {this.props.match.params.lectureId ?
                            <a className="btn btn-default" href={"/video/item/" + this.props.match.params.lectureId} target="_99video"><i className="zmdi zmdi-open-in-new" /> &nbsp;Open Lecture Page</a>
                        : null}&nbsp;
                        {this.props.match.params.lectureId ?
                            <a 
                                className="btn btn-primary"
                                href={`/add-lecture/${this.props.chapterPartInfo.courseId}/${this.props.chapterPartInfo.subjectId}/${this.props.chapterPartInfo.subjectChapterId}/${Number(this.props.chapterPartInfo.number) + 1}`}>
                                <i className="zmdi zmdi-plus" /> &nbsp;
                            Add another</a>
                            :
                            <a 
                                className="btn btn-primary"
                                href={`/add-lecture/${this.props.match.params.courseId}/${this.props.match.params.subjectId}/${this.props.match.params.chapterId}/${Number(this.props.match.params.number) + 1}`}>
                                <i className="zmdi zmdi-plus" /> &nbsp;
                                Add another</a>
                        }
                    </div>
                </div>
            </div>
        )
    }
        

    renderTabsHeader = () => (
        <ul
            className="nav nav-tabs"
            id="ChapterPartVideoTab"
        >
            <li className="active">
                <a
                    href="#chapter_part_basic_info"
                    data-toggle="tab"
                >
                    Basic Info
                </a>
            </li>
            {this.props.chapterPartInfo.id &&
            <li>
                <a
                    href="#chapter_part_video_questions"
                    data-toggle="tab"
                    className={!this.props.match.params.lectureId ? 'disabled' : ''}
                >
                    Video Questions
                </a>
            </li>
            }
            {this.props.chapterPartInfo.id &&
            <li>
                <a
                    href="#chapter_part_quiz_questions"
                    data-toggle="tab"
                    className={!this.props.match.params.lectureId ? 'disabled' : ''}
                >
                    Quiz Questions
                </a>
            </li>
            }
            {this.props.chapterPartInfo.id &&
            <li>
                <a
                    href="#video_discussion"
                    data-toggle="tab"
                    className={!this.props.match.params.lectureId ? 'disabled' : ''}
                >
                    Discussion
                </a>
            </li>
            }

        </ul>
    );
    
    initLecture = (id) => {
        this.props.getChapterPart(id, this.props.user.id);
        this.props.setDefaultUploadProgress();
    }

    setDefaultUploadProgress = () => {
        this.props.setDefaultUploadProgress();
    }

    componentDidMount() {
        let params = {};
        if(this.props.match.params.lectureId && !this.state.calledLoad){

                this.initLecture(this.props.match.params.lectureId);    
            
            
        }else{
            this.setDefaultUploadProgress();
        }
    }
    
    componentWillUpdate(props, state){
        if(this.props.match.params.lectureId !== props.match.params.lectureId){
            this.initLecture(props.match.params.lectureId);
        }
        
        if(!props.match.params.lectureId && props.added){
            if(this.state.image){
                props.uploadImage(state.image, props.chapterPartInfo.id, props.user.id);
                this.setState({image: null});
            }

            this.props.history.push('/edit-lecture/' + props.chapterPartInfo.id);
        }else if(!props.match.params.lectureId && props.match.url !== this.props.match.url){
            this.setDefaultUploadProgress();
        }
        
    }


    updateVideoFile(video){
        // No
    }

    saveImage = (data) => {

        if(this.props.chapterPartInfo.id) {
            this.props.uploadImage(data, this.props.chapterPartInfo.id, this.props.user.id);
        }else{
            this.setState({image: data});
        }
    }
    
    saveBannerImage = (data) => {

        if(this.props.chapterPartInfo.id) {
            this.props.uploadBannerImage(data, this.props.chapterPartInfo.id, this.props.user.id);
        }else{
            this.setState({image: data});
        }
    }

    saveVideoQuestion = (data) => {
        this.props.addVideoQuestion(data, this.props.chapterPartInfo.id, this.props.user.id);

    }

    onVideoQuestionDelete = (id, token) => {
        this.props.deleteVideoQuestion(id, token);
    }

    saveQuizQuestion = (data, files) => {
        this.props.addQuizQuestion(data, files, this.props.chapterPartInfo.id, this.props.user.id);

    }

    onQuizQuestionDelete = (id) => {
        this.props.deleteQuizQuestion(id, this.props.user.id);
    }

    onSave = () => {
        // Get the chapter part, and the video.  Check if there is a video -> chapterPart.video id mismatch
        // If so, hit api/VideoFiles/<id> in patch mode, to update chapterVideoId == video.id

    }

    updateVideoQuestion = (data) => {
        this.props.updateVideoQuestion(data, this.props.user.id);
    }
    
    onVideoComplete = () => {
        
    }

    render() {
        let {view} = this.state;

        return (
            <div
                className="content-wrapper"
                id="content-container"
            >
                {this.renderContentHeader()}
                <section className="content">

                        <VideoEditContainer
                            hasLecture={(this.props.match.params.lectureId) ? true : false}
                            rewindTo={this.state.timeRewindTo}
                            subjectId={this.props.match.params.subjectId || ''}
                            chapterId={this.props.match.params.chapterId || ''}
                            courseId={this.props.match.params.courseId || ''}
                            number={this.props.match.params.number || 0}
                            marks={this.props.chapterPartInfo.VideoQuestions || []}
                            chapterVideo={this.props.chapterPartInfo || null}
                            onUpdateVideo={this.updateVideoFile}
                            saveVideoQuestion={this.saveVideoQuestion}
                            video={(this.props.chapterPartInfo.VideoFile) ? this.props.chapterPartInfo.VideoFile.length > 0 ? this.props.chapterPartInfo.VideoFile[0] : {} : {}}
                        />
                        
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="nav-tabs-custom">
                                {this.renderTabsHeader()}
                                <div className="tab-content no-bg no-padding">
                                    
                                    <EditBasicInfoContainer
                                        enableReinitialize={true}
                                        chapter={this.props.chapterPartInfo}
                                        subjectId={this.props.match.params.subjectId || ''}
                                        chapterId={this.props.match.params.chapterId || ''}
                                        courseId={this.props.match.params.courseId || ''}
                                        number={this.props.match.params.number || 0}
                                        id={this.state.urlParams.id}
                                        onSave={this.onSave}
                                        onUploadImage={this.onImageUpload}
                                        view={this.props.match.params.lectureId ? 'edit' : 'add'}
                                        onSaveImage={this.saveImage}
                                        onSaveBanner={this.saveBannerImage}
                                        user={this.props.user}
                                        profile={this.props.profile}
                                    />
                                    
                                    
                                    {this.props.chapterPartInfo.VideoQuestions &&
                                    <EditVideoQuestionsContainer
                                        getTimeToRewind={this.getTimeToRewind}
                                        questions={this.props.chapterPartInfo.VideoQuestions || []}
                                        saveQuestion={this.updateVideoQuestion}
                                        onVideoQuestionDelete={(id) => this.onVideoQuestionDelete(id, this.props.user.id)}
                                        user={this.props.user}

                                    />
                                    }
                                    
                                    {this.props.chapterPartInfo.VideoQuestions &&
                                    <EditQuizQuestionsContainer
                                        getTimeToRewind={this.getTimeToRewind}
                                        questions={this.props.chapterPartInfo.QuizQuestions || []}
                                        saveQuizQuestion={this.saveQuizQuestion}
                                        deleteQuestionFile={this.props.deleteQuestionFile}
                                        onQuizQuestionDelete={this.onQuizQuestionDelete}
                                        user={this.props.user}
                                        updateQuestionNumbers={(q) => this.props.updateQuestionNumbers(q, this.props.user.id)}
                                        chapterVideoId={this.props.chapterPart ? this.props.chapterPart.id : ''}
                                    />
                                    }

                                    {this.props.discussion &&
                                    <VideoDiscussion
                                        discussion={this.props.discussion}
                                        onPost={(comment) => this.props.postDiscussion(comment, this.props.user.user, this.props.user.id)}
                                        onPostComment={(comment) => this.props.postComment(comment, this.props.user.user, this.props.user.id)}
                                        postLike={(like) => this.props.postLike(like)}
                                        deleteLike={(like) => this.props.deleteLike(like)}
                                        user={this.props.user}
                                        chapterVideoId={this.props.chapterPartInfo.id}
                                        showByDefault={false}
                                        deleteDiscussion={this.props.deleteDiscussion}
                                        deleteComment={this.props.deleteComment}
                                        isAdmin={true}
                                        deleteAll={() => this.setState({showDeleteModal: true})}
                                    />
                                    }
                                </div>
                            </div>
                        </div>
                        

                        <ModalDeleteDiscussions
                            showModalDeleteDiscussions={this.state.showDeleteModal}
                            hideModalDelete={() => this.setState({showDeleteModal: false})}
                            deleteDiscussionConfirmation={(id) => this.props.deleteAllDiscussions(id, this.props.user.id)}
                            chapterVideoId={this.props.chapterPartInfo.id}
                        />
                    </div>
                </section>
            </div>
        );
    }
}

export default EditChapterPart;


// WEBPACK FOOTER //
// ./src/components/EditChapterPart/EditChapterPart.js